import React, { useState } from "react";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "../../lib/api";

const LABELS = { pending_payment: "Pending payment", confirmed: "Confirmed (payment received)", cancelled: "Cancelled", annulled: "Annulled" };

export function StatusChanger({ kind, reference, current, statuses, onDone, testPrefix }) {
  const [status, setStatus] = useState("");
  const [remark, setRemark] = useState("");
  const [busy, setBusy] = useState(false);
  const options = statuses.filter((s) => s !== current);

  const apply = async () => {
    if (!status) { toast.error("Choose a new status."); return; }
    if (!remark.trim()) { toast.error("Please add a remark explaining the change."); return; }
    setBusy(true);
    try {
      await api.post(`/admin/${kind}/${reference}/status`, { status, remark: remark.trim() });
      toast.success(`Status changed to ${LABELS[status]}`);
      setStatus(""); setRemark("");
      onDone();
    } catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail)); }
    finally { setBusy(false); }
  };

  return (
    <div data-testid={`${testPrefix}-status-changer`} className="rounded-xl border border-[#E2EBF0] bg-slate-50 p-3 mt-4">
      <div className="text-xs font-semibold uppercase tracking-widest text-[#008057] mb-2">Change status</div>
      <div className="flex flex-col sm:flex-row gap-2">
        <select data-testid={`${testPrefix}-status-select`} value={status} onChange={(e) => setStatus(e.target.value)} className="rounded-xl border-2 border-[#E2EBF0] px-3 py-2 text-sm bg-white">
          <option value="">New status...</option>
          {options.map((s) => <option key={s} value={s}>{LABELS[s]}</option>)}
        </select>
        <input data-testid={`${testPrefix}-status-remark`} value={remark} onChange={(e) => setRemark(e.target.value)} placeholder="Remark (required), e.g. late payment received" className="flex-1 rounded-xl border-2 border-[#E2EBF0] px-3 py-2 text-sm bg-white" />
        <button data-testid={`${testPrefix}-status-apply`} onClick={apply} disabled={busy} className="rounded-full bg-[#03281B] text-white px-5 py-2 text-sm font-bold disabled:opacity-60">{busy ? "Saving..." : "Apply"}</button>
      </div>
      {status === "confirmed" && <p className="text-xs text-slate-500 mt-2">Marks the payment as received, sends the confirmation email and allocates a jersey gift if one is still available.</p>}
    </div>
  );
}
